import { render, staticRenderFns } from "./SafeSetting.vue?vue&type=template&id=a4aa92ee&scoped=true"
import script from "./SafeSetting.vue?vue&type=script&lang=js"
export * from "./SafeSetting.vue?vue&type=script&lang=js"
import style0 from "./SafeSetting.vue?vue&type=style&index=0&id=a4aa92ee&prod&scoped=true&lang=css"
import style1 from "./SafeSetting.vue?vue&type=style&index=1&id=a4aa92ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4aa92ee",
  null
  
)

export default component.exports